import React from 'react';
import { createUseStyles } from 'react-jss';
import { isMobile } from 'react-device-detect';
import { eventTypes } from '../notificationConstants';
import { useTranslation } from 'react-i18next';

import { TimeAndBadgeComponent } from './common';

const useStyle = createUseStyles({
  notificationBodyTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerTextStyle: {
    color: '#111',
    fontSize: '12px',
    fontWeight: 600,
  },
  userName: {
    color: '#666',
    textAlign: 'right',
    fontSize: '12px',
    fontWeight: 400,
  },
});
const CreateHeaderForNotificationBody = (props) => {
  const { t } = useTranslation();
  const { item, entityIdPrettyName, classes, sourceName, extraData } = props;
  switch (item) {
    case 'issue_comment':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('added a')}{' '}
          </span>
          <span className={classes.headerTextStyle}>{t('Comment')} </span>
          {entityIdPrettyName && (
            <>
              {t('on')}{' '}
              <span className={classes.headerTextStyle}>
                {entityIdPrettyName}
              </span>
            </>
          )}
        </span>
      );
    case 'issue_status_changed':
    case 'issue_assignee_changed':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('changed_the')}{' '}
          </span>
          <span className={classes.headerTextStyle}>
            {item === 'issue_status_changed' ? t('Status') : t('Assignee')}{' '}
          </span>
          {entityIdPrettyName && (
            <>
              {t('of')}{' '}
              <span className={classes.headerTextStyle}>
                {entityIdPrettyName}
              </span>
            </>
          )}
        </span>
      );
    case 'issue_created':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('created the')}{' '}
          </span>
          <span className={classes.headerTextStyle}>{t('Incident')} </span>
          <span className={classes.headerTextStyle}>{entityIdPrettyName}</span>
        </span>
      );
    case 'issue_assignee_added':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('New ticket assigned to you')}{' '}
          </span>
          <span className={classes.headerTextStyle}>{entityIdPrettyName}</span>
        </span>
      );
    case 'issue_assignee_removed':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('Your Ticket')}{' '}
          </span>
          <span className={classes.headerTextStyle}>{entityIdPrettyName}</span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('has been unassigned')}
          </span>
        </span>
      );
    case 'issue_custom_property_changed':
      return (
        <span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('updated')}{' '}
          </span>
          <span className={classes.headerTextStyle}>
            {extraData?.message?.split(',')[0]}
          </span>
          <span className={classes.headerTextStyle} style={{ fontWeight: 400 }}>
            {' '}
            {t('with')}{' '}
          </span>
          <span className={classes.headerTextStyle}>
            {extraData?.message?.split(',')[1]}
          </span>
        </span>
      );
    default:
      return null;
  }
};
export const CreateTitleForNotificationBody = (props) => {
  const classes = useStyle();
  const {
    item,
    ticketName,
    sourceName,
    notificationId,
    notificationStatus,
    setNotificationStatus,
  } = props;
  return (
    <div className={classes.notificationBodyTitle}>
      <div>
        <span className={classes.userName}>{item.actionUser.userName}</span>
        <CreateHeaderForNotificationBody
          item={eventTypes?.[sourceName]?.[item?.eventType]}
          entityIdPrettyName={ticketName}
          classes={classes}
          sourceName={sourceName}
          extraData={item?.extraData}
        />
      </div>
      {!isMobile && (
        <TimeAndBadgeComponent
          item={item}
          notificationId={notificationId}
          notificationStatus={notificationStatus}
          setNotificationStatus={setNotificationStatus}
        />
      )}
    </div>
  );
};
